import styled, {css} from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {CenterPlainLinkStyledButton, SecondaryButton, UnstyledLinkStyledButton} from '../../../styledComponents/Button'
import { Tabs, Tab } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {currentMedia} from '../../../styledComponents/ResponsiveConvenience'
import PreformattedDiv from '../../../styledComponents/PreformattedDiv'
import {StyledHR} from '../../../styledComponents/StyledTypeDefinitions'

export const StyledReservationStatus = styled.div<{ editMode?: boolean }>`
  display: flex;
  justify-content: center;
  width: 68px;
  height: 18px;
  font-size: ${FontSize.Small};
  background-color: ${props => props.editMode ? `rgba(0, 131, 138, 0.25)` : `${Colors.Background}`}
}

;
`
export const ReservationFlexContainer = styled.div`
  display: flex;
  align-items: flex-start;
  ${currentMedia.lessThan('sp')`
    flex-direction: column;
  `}
  ${currentMedia.greaterThan('pc')`
    flex-direction: row;
  `}
`
export const StyledReservationDetail = styled.div`
  line-height: 18px;
  font-size: ${FontSize.Small};
`
export const StyledNote = styled.div`
  font-size: ${FontSize.Middle};
  color: ${Colors.AccentDark};
  margin-top: 10px;
`
export const StyledPageTitle = styled.div`
  font-size: ${FontSize.Big};
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
`

export const StyledSecondaryButton = styled(SecondaryButton)`
  background-color: transparent;
`
export const StyledCancelButton = styled(CenterPlainLinkStyledButton)`
  color: ${Colors.Alert};
`

export const CardList = styled.div`
  display: flex;
  box-sizing: border-box;
  ${currentMedia.lessThan('sp')`
    flex-direction: column;
    align-items: center;
  `}
  ${currentMedia.greaterThan('pc')`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  `}

  width: 100%;
`

export const CardWidth = css`
  ${currentMedia.lessThan('sp')`
    width: 100%;
    max-width: 384px;
  `}
  ${currentMedia.greaterThan('pc')`
    width: 354px;
    max-width: 354px;
  `}
`

// export const StyledCardOuter = styled.div`
//   position: relative;
//   height: 130px;
//   margin-top: 20px;
//   box-shadow: 0 1px 8px 0 rgba(112, 112, 112, 0.4);
//   ${CardWidth}
// `
//
// export const StyledCard = styled.label`
//   border-radius: 4px;
//   background-color: ${Colors.Surface};
//   &:hover {
//     cursor: pointer;
//   }
// `

export const StyledCard = styled.label`
  display: block;
  position: relative;
  margin-top: 20px;
  border-radius: 4px;
  background-color: ${Colors.Surface};
  box-shadow: 0 1px 8px 0 rgba(112, 112, 112, 0.4);

  &:hover {
    cursor: pointer;
  }
  ${CardWidth}
`

export interface EllipsisTextProps {
    lineHeightInPixel: number
    numOfLines: number
    backgroundColor?: string
}

export const EllipsisText = styled.div<EllipsisTextProps>`
  line-height: ${props => props.lineHeightInPixel}px;
  max-height: ${props => props.lineHeightInPixel * props.numOfLines}px;
  position: relative;
  overflow: hidden;

  &:before,
  &:after {
    position: absolute;
    background-color: ${props => props.backgroundColor || Colors.Surface};
  }

  &:before {
    content: "...";
    top: ${props => props.lineHeightInPixel * (props.numOfLines - 1)}px;
    right: 0;
  }

  &:after {
    content: "";
    width: 100%;
    height: 100%;
  }
`

export const ExpandButton = styled.div<{ open: boolean }>`
  padding: 0;
  margin: 0;
  width: 24px;
  height: 24px;

  :before {
    content: '';
    width: 12px;
    height: 12px;
    display: block;
    border-top: solid 2px;
    border-right: solid 2px;
    ${props => props.open ? `transform: rotate(-45deg)` : `transform: rotate(135deg)`};
    position: relative;
    ${props => props.open ? `top: 8px` : `top: 0`};
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
`

export const CoverImage = styled.span<{ url: string }>`
  display: inline-block;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: ${props => `url(${props.url})`};
`

export const CompleteImageArea = styled.div`
  text-align: center;
`
export const CompleteMessage = styled.div`
  font-size: ${FontSize.Big};
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
  text-align: center;
`

export const ViewOnlyModeMessage = styled(PreformattedDiv)`
  color: ${Colors.Alert};
  line-height: 1.25;
  font-weight: ${FontWeights.Bold};
  font-size: ${FontSize.Body};
`

export const DialogTitleArea = styled.div`
  margin: 10px;
`

export const DialogTitle = styled.div`
  font-size: ${FontSize.Accent};
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
  margin-left: 5px;
`

export const DialogCloseButton = styled(UnstyledLinkStyledButton)`
  height: 44px;
  width: 44px;
  color: ${Colors.AccentDark};
`

export const DisplayItemDividerDialog: StyledHR = styled.hr`
  border: none;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid ${Colors.AccentLight};
`

export const ToggleButton = styled.button<{ toggle: boolean }>`
  color: ${props => props.toggle ? Colors.Primary : Colors.Body};
  font-size: ${FontSize.Middle};
  font-weight: ${props => props.toggle ? FontWeights.Bold : FontWeights.Normal};
  height: 30px;
  padding: 0 15px;
  border-radius: 15px;
  border: solid 1px ${props => props.toggle ? Colors.Primary : Colors.AccentLight};
  background-color: ${Colors.Surface};
  margin-right: 10px;
  margin-bottom: 10px;
`

export const TabsStyled = withStyles({
    root: {
        borderBottom: `2px solid ${Colors.AccentLight}`,
        minHeight: '40px',
        overflow: 'visible',
    },
    fixed: {
        overflow: 'visible !important',
    },
    indicator: {
        backgroundColor: `${Colors.Primary}`,
        transform: 'translateY(2px)',
    },
})(Tabs)

export const TabStyled = withStyles({
    root: {
        fontSize: `${FontSize.Middle}`,
        fontFamily: 'Noto Sans JP,sans-serif',
        minHeight: '40px',
        color: 'rgba(80, 80, 80, 0.75)',
    },
    selected: {
        color: `${Colors.Primary}`,
    },
})(Tab)
